type AddressMap = { [chainId: string]: string }

export const META_JUNGLE_ADDRESS: AddressMap = {
    '0x539': "0x9A676e781A523b5d0C0e43731313A708CB607508",
    '0x4': "0x5880F43Daf818d5B1c574881F192B5b3e2565289",
}
export const JUNGLE_RESOURCE: AddressMap = {
    '0x539': "0x8e80FFe6Dc044F4A766Afd6e5a8732Fe0977A493",
    '0x4': "0x1cdd192fd29B05323C16B67Bf2cc035b9672C448",
}